<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'info-especifica', title: '9.1 Información, documentos, reportes específicos' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="9. Obligación de reporte de información específica" />
</template>
